import fetchToken from '../methods/fetch-token';
import retrieveOrFetchToken from '../methods/retrieve-or-fetch-token';
import fetchWithTokenManagement from '../methods/fetch-with-token-management';

export const trueFitService = {
    fetchToken,
    retrieveOrFetchToken,
    fetchWithTokenManagement,
};
